
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Settings, Activity } from 'lucide-react';
import { useMobileMenu } from './MobileMenuContext';

const MobileUserMenuItems = () => {
  const navigate = useNavigate();
  const { closeMenu } = useMobileMenu();

  const handleNavigation = (path: string) => {
    try {
      navigate(path);
    } catch (error) {
      console.error('Navigation failed:', error);
    } finally {
      closeMenu();
    }
  };

  const userMenuItems = [
    { icon: User, label: 'Profile', path: '/profile' },
    { icon: Settings, label: 'Settings', path: '/settings' },
    { icon: Activity, label: 'My Activity', path: '/dashboard' },
  ];

  return (
    <div>
      <h3 className="text-sm font-semibold text-muted-foreground mb-3 uppercase tracking-wider">
        Account
      </h3>
      <div className="space-y-1">
        {userMenuItems.map((item) => (
          <button
            key={item.path}
            onClick={() => handleNavigation(item.path)}
            className="flex items-center gap-3 w-full p-3 rounded-lg hover:bg-muted/50 transition-colors"
          >
            <item.icon className="h-5 w-5 text-muted-foreground" />
            <span className="font-medium">{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MobileUserMenuItems;
